'use client';

import {
  BACKUP_VERSION,
  parseApprovedBackup
} from '@shared/utils/helpers/verificationBackup';
import type {
  ApprovedAvatar,
  ApprovedSet
} from '@shared/utils/storage/approvedVerificationStorage';

type BackupFile = {
  version: number;
  userId: number;
  generatedAt: string;
  approvedBios: string[];
  approvedAvatars: ApprovedAvatar[];
};

export const downloadBackup = (userId: number, set: ApprovedSet): void => {
  const payload: BackupFile = {
    version: BACKUP_VERSION,
    userId,
    generatedAt: new Date().toISOString(),
    approvedBios: set.approvedBios,
    approvedAvatars: set.approvedAvatars
  };
  const blob = new Blob([JSON.stringify(payload)], {
    type: 'application/json'
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `factiii-verification-${userId}.json`;
  a.click();
  URL.revokeObjectURL(url);
};

export const parseBackup = async (
  file: File,
  expectedUserId: number
): Promise<ApprovedSet> => {
  return parseApprovedBackup(await file.text(), expectedUserId);
};
